export const coveragesId = {
  getMyPolicyButton: 'coveragesGetMyPolicyButton',
  understandingMyPlanButton: 'coveragesUnderstandingMyPlanButton',
};
